import { put, takeEvery } from "redux-saga/effects";

import { ApiGatewayApi } from "api";
import { addNotification, loading } from "layouts/AppLayout/modules";
import * as Actions from "../actions/FetchOrganization";
import { Organization } from "generated/graphql";

export function* fetchOrganization(action: Actions.FetchOrganizationAction) {
    const { credentials, organizationId, selectOnSuccess } = action.payload;

    try {
        const api = new ApiGatewayApi({
            xappUserToken: credentials.accessToken
        });
        yield put(loading(true, action));

        const org: Organization = yield api.getOrg(organizationId);
        yield put(Actions.fetchOrganizationEnd(undefined, org, selectOnSuccess));
    } catch (e) {
        yield put(addNotification(e.message, true));
        yield put(Actions.fetchOrganizationEnd(e));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchFetchOrganization() {
    yield takeEvery(Actions.FETCH_ORGANIZATION, fetchOrganization);
}
